<template>
    <div>
        <div style="margin-bottom: 28px; display: flex; flex-direction: row; justify-content: space-between; align-items: center;" class="flex-wrap">
            <h2 style="font-weight: 600; font-size: 18px; margin-bottom: 0;">Stock QR per Dealer</h2>
            <div class="d-flex flex-row flex-wrap align-items-center">
                <div class="mr-3 d-flex">
                    <div class="mr-2" style="font-size: 15px;">Total QR : {{numberWithCommas(stockQr)}}</div>
                    <i id="totalQr"><img src="@/assets/img/icon/info-square.svg" alt=""></i>
                    <b-popover
                    target="totalQr"
                    triggers="hover focus"
                    placement="bottom"
                    :content="'Jumlah stok QR seluruh dealer'"
                    ></b-popover>
                </div>
                <div>
                    <button
                        type="button"
                        class="btn"
                        style="background-color: white; padding: 4.5px 20px; border-radius: 4px; display: flex; align-items: center; font-size: 14px; cursor: pointer; font-weight: 500; border: 1px solid #e8e8e8; display: none;"
                        @click="downloadAll">
                        <i class="fas fa-file-download mr-2"></i>
                        Download 
                    </button>
                </div>
            </div>
        </div>
        <datatable></datatable>
    </div>
</template>


<script>
import moment from 'moment'
import datatable from './children/datatable.vue'
import * as XLSX from 'xlsx'

export default {
    metaInfo : {
        title : 'QR Stock by Dealer'
    },
    components : {
        datatable
    },
    data() {
        return {
            stockQr : 0,
        }
    },
    beforeMount () {
        document.getElementById('content').style.background = '#F8F8F8';
    },
    beforeDestroy () {
        document.getElementById('content').style.background = '';
    },
    mounted () {
        this.fetchData()
    },
    watch : {
    },
    methods : {
        fetchData() {
            this.$http.get(`/api/qrs/qr-stock`)
            .then((resp)=>{
                this.stockQr = resp.data.data.total

                // for cache
                this.$http.get(`/api/qrs/qr-stock-list`)
            })
            .catch((err)=>{console.log(err)})
        },

        async downloadAll() {
            this.$http.get(`/api/qrs/qr-stock-list`)
                .then(async res => {
                    let response = res.data.data;
                    try {
                        const customHeaders = {
                            'name': 'Nama Dealer',
                            'kode_dealer': 'Kode Dealer',
                            'stock': 'Stok QR',
                        };
                        
                        const modifiedData = response.map(item => {
                            const newItem = {};
                            for (const [oldKey, newKey] of Object.entries(customHeaders)) {
                                if (item.hasOwnProperty(oldKey)) {
                                    newItem[newKey] = item[oldKey];
                                }
                            }
                            for (const key in item) {
                                if (!customHeaders.hasOwnProperty(key) && key !== 'day_diff') {
                                    newItem[key] = item[key];
                                }
                            }
                            return newItem;
                        });

                        const worksheet = XLSX.utils.json_to_sheet(modifiedData);
                        const workbook = XLSX.utils.book_new();
                        XLSX.utils.book_append_sheet(workbook, worksheet, 'Sheet1');
                        const timestamp = moment().format('YYYY-MM-DD_HH-mm-ss');
                        const filename = `stock_qr_code_${timestamp}.csv`;
                        XLSX.writeFile(workbook, filename, { bookType: 'csv' });

                    } catch (error) {
                        console.error('Error fetching data or exporting CSV:', error);
                    }
                })
                .catch((err)=>console.log(err));
        },
    }
}
</script>